import { takeEvery, put, call, select } from 'redux-saga/effects'
import { setFieldValue } from '../form'
import {
  //company details
  SEARCH_COMPANY_DETAILS,
  //company address
  LOAD_SELECTED_COMPANY
} from '../constants'

import {
  //search company details
  searchCompanyDetailsSuccess
} from '../actions/index'
import { employerSide } from '../routerHistory'
import { getLocation } from '../selectors/employer/register.selector'

// search company details
function* companyDetailsSearch({ companyName }) {
  try {
    const API_URL =
      'https://avoindata.prh.fi/opendata-ytj-api/v3/companies?name='
    const URL = `${API_URL}${companyName}`

    const response = yield call(fetch, URL)
    const data = yield call([response, response.json])
    const companyDetails = data.companies

    yield put(searchCompanyDetailsSuccess(companyDetails))
  } catch (e) {
    // console.warn(e)
  }
}

// fetch company address
function* loadSelectedCompanySaga({ selectedCompany, formName }) {
  try {
    const response = yield call(fetch, selectedCompany)
    const data = yield call([response, response.json])
    const selectedCompanyDetails = data.companies[0]
    const { businessId, name, streetAddress, city, zipCode } = mapCompanyData(
      selectedCompanyDetails
    )
    const location = yield select(getLocation)

    const fields = [
      { field: 'company_name', value: name },
      {
        field:
          employerSide && location === '/dashboard/employerRegister'
            ? 'y_tunnus'
            : 'business_id',
        value: businessId
      },
      { field: 'delivery_address', value: streetAddress },
      { field: 'address', value: streetAddress },
      { field: 'city', value: city },
      { field: 'zip_code', value: zipCode }
    ]
    yield put(setFieldValue(formName, fields))
  } catch (e) {
    // console.warn(e)
  }
}

function mapCompanyData(company) {
  const businessId = company.businessId?.value || ''
  const name = company.names?.[0]?.name || ''
  const address = company.addresses?.[0] || {}

  const streetAddress = [
    address.street,
    address.buildingNumber,
    address.entrance
  ]
    .filter(Boolean)
    .join(' ')

  const city =
    address.postOffices?.find((postalOffice) => postalOffice.languageCode == 1)
      ?.city || ''

  const zipCode = address.postCode || ''

  return { businessId, name, streetAddress, city, zipCode }
}

//fetch company
export function* watchCompanyDetailsSearch() {
  yield takeEvery(SEARCH_COMPANY_DETAILS, companyDetailsSearch)
}

//fetch company address
export function* watchLoadSelectedCompanySaga() {
  yield takeEvery(LOAD_SELECTED_COMPANY, loadSelectedCompanySaga)
}
